import { DialogTitle, IconButton } from "@mui/material";
import { LuX } from "react-icons/lu";

// The title bar of every modal: the title on the left, a close (X) button on the right. `disabled` while the
// modal is busy saving, like the backdrop click / Escape which are blocked then too.
const DialogTitleWithClose = ({ children, onClose, disabled = false }) => (
  <DialogTitle sx={{ fontSize: 16, fontWeight: 600, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2, pr: 1.5 }}>
    <span>{children}</span>
    {onClose && (
      <IconButton size="small" aria-label="Close" onClick={onClose} disabled={disabled} sx={{ flexShrink: 0 }}>
        <LuX />
      </IconButton>
    )}
  </DialogTitle>
);

export default DialogTitleWithClose;
